import { useContext } from 'react';
import { SubscriptionFeaturesContext } from './subscription-features-provider';

/**
 * useSubscriptionFeatures()
 * Hook for accessing subscription features in context, to be used with functional components
 * @param features
 * @returns
 */
export const useSubscriptionFeatures = features => {
  if (!features.length) {
    throw new Error('useSubscriptionFeatures must be called with at least one feature');
  }
  const {
    subscriptionFeatures: providerSubscriptionFeatures,
    isLoading: providerIsLoading
  } = useContext(SubscriptionFeaturesContext);
  const subscriptionFeatures = new Map();
  for (const feature of features) {
    if (providerSubscriptionFeatures.has(feature)) {
      subscriptionFeatures.set(feature, providerSubscriptionFeatures.get(feature));
    }
  }
  return {
    isLoading: providerIsLoading,
    subscriptionFeatures
  };
};
//# sourceMappingURL=use-subscription-features.js.map